import React from 'react';
import PillNav from './PillNav';
import Logo from '../assets/images/eraintrerio-01.png';

const Header = () => {
  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about-us' },
    { label: 'Services', href: '/services' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'Contact', href: '/contact-us' },
     { label: 'Blog', href: '/blog' }
  ];

  return (
    <header className="main-header">
      <div className="pill-nav-container">
        <PillNav
          logo={Logo}
          logoAlt="Era Interio Logo"
          items={navItems}
          baseColor="#ffffff"
          pillColor="rgba(149, 186, 214, 0.45)"
          hoveredPillTextColor="#000000"
          pillTextColor="#000000"
          ctaButtonText="Get in Touch"
          ctaButtonHref="/contact-us"
          ctaButtonColor="#7C877F"
        />
      </div>
    </header>
  );
};

export default Header;